import React from "react";
import ReactECharts from "echarts-for-react";
import moment from "moment";
import download from "./downloadCSV.jpg";


class LongTermMonthlyChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      option: {
        title: {
          text: this.props.rname[0],
          subtext: this.props.rname[1],
          left: "center",
          textStyle: {
            fontSize: 16,
            color: "#0000ff",
          },
          subtextStyle: {
            fontSize: 14,
            color: "#0000ff",
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#333",
          borderColor: "#777",
          borderWidth: 1,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          top: '15%',
          bottom: '20%',
          left: '10%',
          right: '0%',
        },
     
        xAxis: {
          type: "category",
          data: this.props.dates,
          // // axisLabel: {
          // //   formatter: function (value) {
          // //     return moment(value, "YYYY-MM").format("MMM YYYY");
          // //   },
          //   rotate: 45,
          // },
          axisTick: {
            alignWithLabel: true,
          },
          name: "Month",
          nameLocation: "center",
          nameTextStyle: {
            color: '#000',
            fontWeight:'bold',
            fontsize:12,


          },
          nameGap: 30,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          name: "Inflow (Cusecs)",
          nameLocation: "center",
          nameTextStyle: {
            fontSize: 12,
            color: '#000',       
                 fontWeight:'bold',

          },
          nameGap: 50,
        },
        series: [
          {
            name: "Inflow (Cusecs)",
            type: "line",
            smooth: true,
            data: this.props.data,
            symbol: "none",

            lineStyle: {
              width: 3,
              color: '#26a0fc',

            },
            //symbolSize: 6,
           
            emphasis: {
              focus: "series",
            },
            animation: true,
            animationDuration: 2000,
            animationEasing: "cubicOut",
          },
        ],
        toolbox: {
          feature: {
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            saveAsImage: {
              title: "Save",
              type: "png",
              name:
                this.props.rname[1]
                  .split("(")[0]
                  .replace(" ", "_") +
                "_LTM_" +
                this.props.date,
            },
            myExportCSV: {  // Custom CSV button
              show: true,
              title: "Export to CSV",
              icon: `image://${download}`,  // You can replace this with the path to your custom icon
              onclick: this.exportToCSV,
            },
          },
        },
        dataZoom: [
        
          {
            type: "inside",
          },
        ],
      },
    };
  }

  handleMinimizeClick = () => {
    this.props.toggleVisibleGraphPanel();
  };
  exportToCSV = () => {
    const { dates, data, title, rname, date } = this.props;

    // Start the CSV content with headers
    let csvContent = `"Date","Inflow (cusecs)"\n`;

    // Loop through dates and data to generate rows
    dates.forEach((dateValue, index) => {
        // Format the date using moment.js
        const formattedDate = dateValue;

        // Get the corresponding data value
        const inflowValue = data[index] || ''; // Handle missing data gracefully

        // Append the row to the CSV content
        csvContent += `${formattedDate},${inflowValue}\n`;
    });

    // Create a Blob containing the CSV data
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });

    // Create a link element to trigger download
    const a = document.createElement('a');
    const filename = `${rname[1].split("(")[0].replace(" ", "_")}_LTM_${date}.csv`;

    a.href = URL.createObjectURL(csvBlob);
    a.download = filename;
    a.click();
};


  render() {
    console.log("this.props.dates", this.props.dates);
    return (
      <div>
        <ReactECharts
          option={this.state.option}
          style={{ width: "95%", height: "350px", margin: "0 auto" }}
        />
      </div>
    );
  }
}

export default LongTermMonthlyChart;
